<script setup lang="ts">
import type AlertModal from "@/components/app/modal/Alert.vue";
import type { ToasterProps } from "@nuxt/ui";

useHead({
  meta: [{ name: "viewport", content: "width=device-width, initial-scale=1" }],
  link: [{ rel: "icon", href: "/favicon.ico" }],
  htmlAttrs: {
    lang: "th",
  },
});

// const title = 'Nuxt Starter Template'
// const description = 'A production-ready starter template powered by Nuxt UI. Build beautiful, accessible, and performant applications in minutes, not hours.'

// useSeoMeta({
//   title,
//   description,
//   ogTitle: title,
//   ogDescription: description,
//   ogImage: 'https://ui.nuxt.com/assets/templates/nuxt/starter-light.png',
//   twitterCard: 'summary_large_image'
// })

const { $alert } = useNuxtApp();

const toaster = {
  position: "top-right",
  progress: false,
  duration: 3000,
} as ToasterProps;

const alertModalRef =
  useTemplateRef<InstanceType<typeof AlertModal>>("alertModalRef");

onMounted(() => {
  $alert.register(alertModalRef.value);
});

onBeforeUnmount(() => {
  $alert.register(null);
});
</script>

<template>
  <UApp :toaster="toaster">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <AppModalAlert ref="alertModalRef"></AppModalAlert>
  </UApp>
</template>
